



























import {Component, Prop, Vue} from 'vue-property-decorator'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import {State} from '@/views/diagnosis/Index.vue'

@Component({
  components: {VueQrcode},
})
export default class AppDownload extends Vue {

  @Prop({type: String})
  public backgroundColor!: string

  get url() {
    const cid = this.$cookies.get('cid')
    const addp = this.$cookies.get('addp') || ''
    let url = 'https://wealth-wing.com/r/qr'
    if (cid) {
      url = `https://wealth-wing.com/r/qr?cid=${cid}&addp=${encodeURI(addp)}`
    }
    return url
  }

  get backgroundColorCode(): string {
    if (this.backgroundColor === 'blue') {
      return '#ECF7FF'
    }
    return '#FFFFFFFF'
  }
}
